import { render } from "./Devx.vue?vue&type=template&id=f61266e0&scoped=true"
import script from "./Devx.vue?vue&type=script&lang=js"
export * from "./Devx.vue?vue&type=script&lang=js"

import "./Devx.vue?vue&type=style&index=0&id=f61266e0&scoped=true&lang=css"

import exportComponent from "/Volumes/INNCOM/MUSOON Project/2103.musoon.mobile.vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f61266e0"]])

export default __exports__